import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import moment from 'angular-moment';

import routing from './weekly_group_report.routes';

import DailyGroupActivePowerService from '../../../components/api/daily_group_active_power/daily_group_active_power.service';
import Chart from '../../../components/directive/chart/chart.directive';
import DateUtil from '../../../components/logic/date_util/date_util.module';
import CsvUtil from '../../../components/logic/csv_util/csv.util';
import MathUtil from '../../../components/logic/math_util/math_util';
import GroupReportUtil from '../../../components/logic/group_report/group_report_util.service';
import chartConfig from './weekly_group_report.config';

export class WeeklyGroupReportController {
  /*@ngInject*/
  constructor($state, $stateParams, $filter, moment, DateUtil, DailyGroupActivePowerService, CsvUtil, GroupReportUtil, MathUtil) {
    this.id = $stateParams.id;
    this.$filter = $filter;
    this.$state = $state;
    this.DailyGroupActivePowerService = DailyGroupActivePowerService;
    this.moment = moment;
    this.DateUtil = DateUtil;
    this.CsvUtil = CsvUtil;
    this.MathUtil = MathUtil;
    this.GroupReportUtil = GroupReportUtil;

    this.targetDate = this.moment().startOf('week');
    this.startDate = this.targetDate.clone().toDate();
    this.endDate = this.targetDate.clone().add(6, 'days').toDate();
    this.maxDate = this.targetDate.clone().toDate();
    this.downloadFileName = 'active_power.csv';

    this.Week = ['日', '月', '火', '水', '木', '金', '土'];

    this.chartConfig = chartConfig(this);
  }

  $onInit() {
    this.updateGraph();
  }

  updateGraph() {
    this.categories = [];
    for (let i = 0; i < 7; i++) {
      let utc = this.DateUtil.localToUTC(this.startDate);
      this.categories.push(this.DateUtil.leapDate(utc, i).valueOf());
    }

    this.DailyGroupActivePowerService.show(
      angular.extend({id: this.id}, this.DateUtil.getDateRangeQueries(this.startDate, this.endDate)),
      response => {
        [this.seriesList, this.sumSeriesList] = this.formatGroupActivePower(response.powers);
        this.chartConfig.xAxis.categories = this.categories;

        if (this.isOverStackLimit) {
          this.chartConfig.series = this.sumSeriesList;
        } else {
          this.chartConfig.series = this.seriesList;
        }

        //add click event
        for(let series of this.chartConfig.series) {
          series.events = {
            click: event => {
              this.$state.go(
                'main.group_report_show.detail',
                { id: this.id, term: 'daily', target: event.point.date },
                { reload: true }
              )
            }
          };
          series.cursor = 'pointer';
        }

        this.sumSeries = this.sumSeriesList[0];
        this.csvData = this.CsvUtil.processDailyGroupActivePower(this.seriesList, this.categories);
        this.downloadFileName = this.moment(this.startDate).format('[group_active_power_]YYYY-MM-DD[_week.csv]');
      }
    )
  }

  formatGroupActivePower(groupActivePowers) {
    if (groupActivePowers.length < 1) {
      return [[], []];
    }

    // 処理内容の詳細については daily_group_report_component.js を参照

    const STACK_LIMIT = 10;
    this.isOverStackLimit = false;

    let firstMeasuredAt = this.moment(groupActivePowers[0].date);
    let beginningDate = this.targetDate;
    let shiftRange = firstMeasuredAt.diff(beginningDate, 'days');

    let seriesList = this.GroupReportUtil.createSeriesList(groupActivePowers, shiftRange);

    if (seriesList.length > STACK_LIMIT) {
      this.isOverStackLimit = true;
    }

    let [stackSeriesList, sumSeriesList] = this.GroupReportUtil.createStackSeries(seriesList, groupActivePowers, shiftRange);

    return [stackSeriesList, sumSeriesList];
  }

  changeDate(diff) {
    this.targetDate.add(diff, 'days');
    this.startDate = this.DateUtil.leapDate(this.startDate, diff);
    this.endDate = this.DateUtil.leapDate(this.startDate, 6);

    this.updateGraph(this.startDate, this.endDate);
  }

  getWeek(timeValue) {
    return this.Week[new Date(timeValue).getDay()];
  }
}

export default angular.module('leptonApp.weeklyGroupReport', [uiRouter, moment, DateUtil, DailyGroupActivePowerService, CsvUtil, GroupReportUtil, MathUtil])
  .config(routing)
  .component('weeklyGroupReport', {
    require: {parentComponent: '^groupReportShow'},
    template: require('./weekly_group_report.html'),
    controller: WeeklyGroupReportController
  })
  .name;



// WEBPACK FOOTER //
// ./public/dev/app/group_report/weekly/weekly_group_report.component.js